import React, { useState } from "react";
import ReactDOM from 'react-dom';
import { Button } from "../Button";
import { showErrorToast, showSuccessToast } from "../../lib/ToastUtility";

interface SecretModalProps {
  open: boolean;
  secret: string;
  title: string;
  onClose: () => void;
}

const SecretModal: React.FC<SecretModalProps> = ({ open, secret, title, onClose }) => {
  const [copied, setCopied] = useState(false);

  if (!open) {
    return null;
  }

  const handleCopy = async () => {
    if (!secret) {
      return;
    }

    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
      showSuccessToast("Secret copied to clipboard");
    } catch (_error) {
      showErrorToast("Could not copy secret. Please copy it manually.");
    }
  };

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-2xl rounded-2xl border border-white/50 bg-white p-6 shadow-xl dark:border-white/10 dark:bg-slate-900"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{title}</h2>

        <p className="mt-3 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:border-amber-700/40 dark:bg-amber-900/20 dark:text-amber-200">
          This secret will not be shown again.
        </p>

        <div className="mt-4">
          <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Kiosk Secret
          </label>
          <textarea
            value={secret}
            readOnly
            rows={4}
            className="w-full rounded-md border border-gray-300 bg-gray-50 p-3 font-mono text-sm focus:outline-none dark:border-white/10 dark:bg-slate-800 dark:text-gray-100"
          />
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCopy}>
            {copied ? "Copied" : "Copy Secret"}
          </Button>
        </div>
      </div>
    </div>
  ,
  document.body
);
};

export default SecretModal;
